export default __webpack_public_path__ + "static/media/full-logo.d988357e.svg";